import React, { useState } from "react";
import { Play } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import Reveal from "./Reveal";
import { proofVideos } from "../mock";

const VideoProof = () => {
  const [active, setActive] = useState(null);

  return (
    <section className="section-navy py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal className="mb-14 max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-[0.22em] text-[#E7625B]">
            Proof
          </span>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-white md:text-4xl">
            Continex in action
          </h2>
          <p className="mt-4 text-lg font-light text-white/70">
            Real footage from trade missions, partnerships and business
            engagements across borders.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {proofVideos.map((v, i) => (
            <Reveal key={v.id} delay={i * 120}>
              <button
                onClick={() => setActive(v)}
                className="group relative block h-64 w-full overflow-hidden rounded-2xl text-left"
              >
                <img
                  src={`https://img.youtube.com/vi/${v.youtubeId}/hqdefault.jpg`}
                  alt={v.title}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0b2038]/90 via-[#0b2038]/30 to-transparent" />
                <div className="absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-[#0F2A4A] shadow-lg transition-all duration-300 group-hover:scale-110 group-hover:bg-white">
                  <Play className="ml-1 h-6 w-6 fill-current" />
                </div>
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <span className="text-xs font-semibold uppercase tracking-[0.16em] text-[#E7625B]">
                    {v.category}
                  </span>
                  <h3 className="mt-1 text-lg font-semibold text-white">
                    {v.title}
                  </h3>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-3xl overflow-hidden p-0">
          <DialogHeader className="px-6 pt-5">
            <DialogTitle className="text-[#0F2A4A]">
              {active?.category} — {active?.title}
            </DialogTitle>
          </DialogHeader>
          <div className="aspect-video w-full">
            {active && (
              <iframe
                key={active.id}
                className="h-full w-full"
                src={`https://www.youtube.com/embed/${active.youtubeId}?autoplay=1&rel=0`}
                title={active.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default VideoProof;
